import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const PendingTiktokBannerWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.background};
  padding: 8px;
`;
